/* @flow */
export const PROVIDER_FACEBOOK: string = 'facebook';
export const PROVIDER_GOOGLE: string = 'google';
export const PROVIDER_APPLE: string = 'apple';
export const PROVIDER_EMAIL: string = 'email';
export const SIGNIN_METHOD: string = 'signin_method';
export const ANONYMOUS: string = 'Anonymous';
